import { Block } from "app/shared/components/blocks/block";
import DataTableView, { ActionDataTable } from "app/shared/components/data-table/data-table.web";
import EmptyBox from "app/shared/components/empty-box/empty-box";
// import { QueueSpacing } from "app/shared/components/spacing";
import { ITEMAUTOTOPUPBILLING } from "app/shared/services/services-model.type";
import { spacing } from "app/shared/styles/spacing";
import { useDesktopMediaQuery } from "app/shared/util/media-query";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { FlatList, ListRenderItem, StyleSheet } from "react-native";
import { useTheme, Paragraph, TouchableRipple, Button } from "react-native-paper";
import { useSelector } from "react-redux";
import { getAutoBillingPendingListAutoSelector } from "../../reducer/selectors";

export interface DataAutoBillingTableProps {
  accountno?: string; //Số tài khoản
  accounttype?: string; //Loại tài khoản
  billno?: string; //Số điện thoại đăng ký topup, ID Giao dịch
  provider?: string | null; //Nhà mạng
  services?: string | null; //Dịch vụ
  packages?: string | null; //Gói dịch vụ
  denominations?: string | null; //Mệnh giá
  status?: string; //A/C (ACTIVE/CLOSE)
  code?: string; //Mã code
  note?: string; //Ghi chú
  reg?: string; // CODE dv
  regdate?: string; // ngày đăng ký format dd/mm/yyyy
  description?: string; //Diễn giải cho mã code
  action?: string;
  paydate?: string | null;
  paynow?: string | null;
  id?: string;
  SERVICE_NAME?: string;
  PROVIDER_NAME?: string;
  PACKAGE_NAME?: string;
  PAY_DATE?: string;
  DENOMINATIONS_CURRENCY?: string;
}

interface AutoBillingRollTableProps {
  onChangeData: (data: ITEMAUTOTOPUPBILLING[]) => void;
  data?: DataAutoBillingTableProps[];
  onPressHistory: (item: any) => void;
  onPressDelete: (item: any) => void;
}

const AutoBillingRollTable = (props: AutoBillingRollTableProps) => {
  const { t } = useTranslation();
  const isDesktop = useDesktopMediaQuery();
  const { colors, fonts } = useTheme();
  const { data = [], onChangeData, onPressHistory, onPressDelete } = props;

  const pending = useSelector(getAutoBillingPendingListAutoSelector);

  const [dataTable, setDataV2Table] = React.useState<DataAutoBillingTableProps[]>([]);
  const [arrayExpand, setArrayExpand] = React.useState<Array<boolean>>([]);
  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        displayShow: {},
        textBold: { ...fonts.medium, color: colors.text, paddingVertical: 0 },
        text: { ...fonts.regular, color: colors.text, paddingVertical: 0 },
        label: { flex: 1, minWidth: "30%" },
        value: { textAlign: "right" },
        textLink: { flex: 1, minWidth: "30%", textDecorationLine: "underline", color: colors.accent, textAlign: "right" },
        buttonContainer: { minWidth: 128, alignSelf: "center", backgroundColor: colors.notification },
        acceptButtonContainer: { minWidth: 128, alignSelf: "center" },
      }),
    [colors.accent, colors.notification, colors.text, fonts.medium, fonts.regular],
  );

  const onPressChildren = React.useCallback(
    (item: any, type?: ActionDataTable) => {
      if (type === "delete") onPressDelete(item);
      else if (type === "show") onPressHistory(item);
    },
    [onPressDelete, onPressHistory],
  );

  const onPressExpand = (_index: number) => {
    const _arrayExpand: Array<boolean> = [];
    arrayExpand.forEach((value, index) => {
      let status: boolean = false;
      if (index === _index) status = !value;
      _arrayExpand.push(status);
      return value;
    });
    console.log("_arrayExpand new: ", _arrayExpand);
    setArrayExpand(_arrayExpand);
  };

  React.useEffect(() => {
    onChangeData(dataTable);
    const _arrayExpand: Array<boolean> = [];
    dataTable.forEach((_item) => {
      _arrayExpand.push(false);
    });
    setArrayExpand(_arrayExpand);
  }, [dataTable, onChangeData]);

  React.useEffect(() => {
    setDataV2Table(data || []);
  }, [data]);

  const FormEmpty = () => {
    return data.length === 0 && !(pending === "init" || pending === "pending") ? (
      <EmptyBox title={t("AUTO_TOPUP_KHONG_CO_GIAO_DICH_NAO")} />
    ) : (
      <></>
    );
  };

  const renderItemDetail: ListRenderItem<DataAutoBillingTableProps> = ({ item, index }) => (
    <React.Fragment key={index}>
      <TouchableRipple onPress={() => onPressExpand(index)}>
        <Block pv={spacing.small} ph={spacing.medium} bg={index % 2 === 0 ? colors.surface : colors.backgroundForm} br={8}>
          <Block row spaced>
            <Paragraph style={[styles.textBold, styles.label]}>{t("AUTO_BILLING_DICH_VU")}</Paragraph>
            <Paragraph style={[styles.textBold, styles.value]}>{item?.SERVICE_NAME}</Paragraph>
          </Block>
          <Block row spaced>
            <Paragraph style={[styles.textBold, styles.label]}>{t("AUTO_BILLING_MA_HOA_DON")}</Paragraph>
            <Paragraph style={[styles.textBold, styles.value]}>{item?.billno}</Paragraph>
          </Block>
          <Block row spaced>
            <Paragraph style={[styles.text, styles.label]}>{t("AUTO_BILLING_NHA_CUNG_CAP")}</Paragraph>
            <Paragraph style={[styles.text, styles.value]}>{item?.PROVIDER_NAME}</Paragraph>
          </Block>
          {arrayExpand[index] === true ? (
            <>
              <Block row spaced>
                <Paragraph style={[styles.text, styles.label]}>{t("AUTO_BILLING_TAI_KHOAN_TRICH_NO")}</Paragraph>
                <Paragraph style={[styles.text, styles.value]}>{item?.accountno}</Paragraph>
              </Block>
              <Block row spaced>
                <Paragraph style={[styles.text, styles.label]}>{t("AUTO_BILLING_NGAY_DANG_KY")}</Paragraph>
                <Paragraph style={[styles.text, styles.value]}>{item?.regdate}</Paragraph>
              </Block>
              <Block row spaced>
                <Paragraph style={[styles.text, styles.label]}>{t("AUTO_BILLING_NGAY_THANH_TOAN")}</Paragraph>
                <Paragraph style={[styles.text, styles.value]}>{item?.PAY_DATE}</Paragraph>
              </Block>
              <Block row middle mv={spacing.small}>
                <Button
                  onPress={() => onPressChildren(item, "delete")}
                  mode="contained"
                  style={[styles.buttonContainer, { backgroundColor: index % 2 === 0 ? colors.notification : colors.surface }]}>
                  {t("COMMON_HUY")}
                </Button>
                {/* <QueueSpacing size="large" />
                <Button onPress={() => onPressChildren(item, "show")} mode="contained" style={styles.acceptButtonContainer}>
                  {t("AUTO_TOPUP_LICH_SU_GIAO_DICH")}
                </Button> */}
              </Block>
            </>
          ) : (
            <></>
          )}
        </Block>
      </TouchableRipple>
    </React.Fragment>
  );

  const renderMobile = (
    <FlatList data={dataTable} keyExtractor={(_item) => String(_item.id)} renderItem={renderItemDetail} initialNumToRender={10} />
  );

  return (
    <Block style={styles.displayShow}>
      {isDesktop ? (
        <DataTableView
          header={[
            {
              name: "#",
              attr: "id",
            },
            {
              name: t("AUTO_BILLING_DICH_VU"),
              attr: "SERVICE_NAME",
            },
            {
              name: t("AUTO_BILLING_MA_HOA_DON"),
              attr: "billno",
            },
            {
              name: t("AUTO_BILLING_NHA_CUNG_CAP"),
              attr: "PROVIDER_NAME",
            },
            {
              name: t("AUTO_BILLING_NGAY_DANG_KY"),
              attr: "regdate",
            },
            {
              name: t("AUTO_BILLING_NGAY_THANH_TOAN"),
              attr: "PAY_DATE",
            },
            {
              name: t("AUTO_BILLING_GHI_CHU"),
              attr: "note",
            },
            // {
            //   name: t("AUTO_BILLING_LICH_SU_GIAO_DICH"),
            //   attr: "status",
            //   action: "show",
            // },
            {
              name: t("COMMON_HUY"),
              attr: "status",
              action: "delete",
            },
          ]}
          onPressRow={() => {}}
          onPressChildren={onPressChildren}
          dataTable={dataTable}
          widthCell={!isDesktop ? 120 : undefined}
        />
      ) : (
        renderMobile
      )}
      <FormEmpty />
    </Block>
  );
};

export default AutoBillingRollTable;
